import React, { useState, useContext } from 'react';
import { Button, Input, Label, Spinner } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faRobot } from '@fortawesome/free-solid-svg-icons';
import { PostData } from '../../../services/FetchData';
import { ProductContext } from '../../../store';
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';

const GenerateAIQuestions = ({ onBack, onRefresh }) => {
    const { currentWebsiteId } = useContext(ProductContext);
    const [skus, setSkus] = useState('');
    const [isGenerating, setIsGenerating] = useState(false);

    const handleGenerate = async () => {
        if (!skus.trim()) {
            toast.error('Please enter at least one SKU');
            return;
        }

        const websiteId = currentWebsiteId || Cookies.get("_website_id");
        
        if (!websiteId) {
            toast.error("Website ID is missing");
            return;
        }

        // Parse SKUs from comma-separated string
        const skuList = skus.split(',').map(sku => sku.trim()).filter(sku => sku.length > 0);
        
        if (skuList.length === 0) {
            toast.error('Please enter valid SKUs');
            return;
        }

        setIsGenerating(true);
        
        try {
            const response = await PostData(
                "ms1",
                "api/v1/aiassistant/generateAIquestions",
                {
                    websiteId: websiteId,
                    skus: skuList
                }
            );

            if (response !== "Invalid" && response !== undefined) {
                if (response.status === "success") {
                    const generatedCount = response.data?.generatedQuestions?.length || 0;
                    toast.success(`Successfully generated ${generatedCount} AI questions for ${skuList.length} products`);
                    
                    // Clear the form
                    setSkus('');
                    
                    // Refresh the questions list to show newly generated questions
                    if (onRefresh) {
                        await onRefresh();
                    }
                    
                    // Navigate back to questions list to see the generated questions
                    setTimeout(() => {
                        onBack();
                    }, 500);
                } else {
                    toast.error(response.message?.message || response.message || "Failed to generate AI questions");
                }
            } else {
                toast.error("Invalid response from server");
            }
        } catch (error) {
            console.error('Error generating AI questions:', error);
            toast.error('Failed to generate AI questions. Please try again.');
        } finally {
            setIsGenerating(false);
        }
    };

    return (
        <div className="generate-ai-questions">
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h2>Generate AI Questions</h2>
                <Button 
                    color="outline-secondary" 
                    onClick={onBack}
                    className="d-flex align-items-center"
                >
                    <FontAwesomeIcon icon={faArrowLeft} className="me-2" />
                    Back to Questions
                </Button>
            </div>

            <div className="card">
                <div className="card-body">
                    <h4 className="mb-3">Generate Product Questions with AI</h4>
                    
                    <div className="mb-3">
                        <Label className="form-label fw-bold">Product SKUs</Label>
                    </div>
                    
                    <div className="mb-3">
                        <Input
                            type="textarea"
                            value={skus}
                            onChange={(e) => setSkus(e.target.value)}
                            placeholder="Enter comma-separated SKUs (e.g., SKU123, SKU456)"
                            rows={4}
                            className="form-control"
                            style={{ resize: 'vertical' }}
                        />
                    </div>
                    
                    <p className="text-muted mb-4">
                        Enter comma-separated SKUs for products you want to generate questions for.
                    </p>
                    
                    <div className="d-flex justify-content-end">
                        <Button 
                            color="primary" 
                            onClick={handleGenerate}
                            disabled={isGenerating}
                            className="d-flex align-items-center conversionBox"
                        >
                            {isGenerating ? (
                                <>
                                    <Spinner size="sm" className="me-2" />
                                    Generating...
                                </>
                            ) : (
                                <>
                                    <FontAwesomeIcon icon={faRobot} className="me-2" />
                                    Generate Questions
                                </>
                            )}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GenerateAIQuestions;
